import gql from 'graphql-tag';

const GET_ADGROUP_CREATIVES_BY_MEDIA = gql`
  query adgroupmedias($media: [ID!], $flag: Boolean = true) {
    adGroupCreativeses(where: { medias_some: { id_in: $media }, flag: true }) {
      id
      medias(where: { flag: $flag }) {
        id
        flag
        name
      }
    }
  }
`;

export default GET_ADGROUP_CREATIVES_BY_MEDIA;
